/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refine_Your_SearchInputs */

const en_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refine your search`)
};

const es_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refinar búsqueda`)
};

const fr_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affinez votre recherche`)
};

const de_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfeinere deine Suche`)
};

const ja_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索条件を絞り込む`)
};

const zh_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精确您的搜索`)
};

const ar_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحسين بحثك`)
};

const id_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persempit pencarian Anda`)
};

const it_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affina la tua ricerca`)
};

const ru_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уточнить поиск`)
};

const pt_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refine sua pesquisa`)
};

const ko_refine_your_search = /** @type {(inputs: Refine_Your_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색 결과 세분화`)
};

/**
* | output |
* | --- |
* | "Refine your search" |
*
* @param {Refine_Your_SearchInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const refine_your_search = /** @type {((inputs?: Refine_Your_SearchInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refine_Your_SearchInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refine_your_search(inputs)
	if (locale === "es") return es_refine_your_search(inputs)
	if (locale === "fr") return fr_refine_your_search(inputs)
	if (locale === "de") return de_refine_your_search(inputs)
	if (locale === "ja") return ja_refine_your_search(inputs)
	if (locale === "zh") return zh_refine_your_search(inputs)
	if (locale === "ar") return ar_refine_your_search(inputs)
	if (locale === "id") return id_refine_your_search(inputs)
	if (locale === "it") return it_refine_your_search(inputs)
	if (locale === "ru") return ru_refine_your_search(inputs)
	if (locale === "pt") return pt_refine_your_search(inputs)
	return ko_refine_your_search(inputs)
});